(function () {
  // Function to apply custom property redefinition and logic
  function observeCurrentPageChange(element, customLogic) {
    let currentValue = element.currentPage;

    Object.defineProperty(element, 'currentPage', {
      get() {
        return currentValue;
      },
      set(newValue) {
        if (currentValue !== newValue) {
          currentValue = newValue;
          if (shouldExecuteLogic(element)) {
            customLogic(newValue);
          }
        }
      },
    });
  }

  function shouldExecuteLogic(element) {
    const className = getClassForLogic(element);
    return document.querySelector(`.reviews--author-list.${className}`);
  }

  function getClassForLogic(element) {
    return element.classList.contains('user-reviews') ? 'user-reviews' : 'pro-reviews';
  }

  function updateActiveAuthor(selector, value) {
    const authorListElement = document.querySelector(selector);
    authorListElement.querySelectorAll('em').forEach((authorName, index) => {
      authorName.classList.toggle('active', index + 1 === value);
    });
  }

  function initActiveAuthor(element) {
    const className = getClassForLogic(element);
    document.querySelector(`.reviews--author-list.${className} em`).classList.add('active');
  }

  // Custom logic functions
  const customLogic = {
    'user-reviews': function (newValue) {
      updateActiveAuthor('.reviews--author-list.user-reviews', newValue);
    },
    'pro-reviews': function (newValue) {
      updateActiveAuthor('.reviews--author-list.pro-reviews', newValue);
    },
  };

  function handleClick(event) {
    const authorList = event.target.closest('.reviews--author-list');
    if (!authorList) return;

    const emElement = event.target.closest('em');
    if (!emElement) return;

    const authorListElements = authorList.querySelectorAll('em');
    authorListElements.forEach((element, index) => {
      if (element === emElement) {
        const slideContainerClass = authorList.classList.contains('user-reviews') ? 'user-reviews' : 'pro-reviews';
        document
          .querySelectorAll(`.reviews--slide-container.${slideContainerClass} .slider-counter--dots button`)
          [index].click();
      }
    });
  }

  // Select all instances of the custom element
  const slideshows = document.querySelectorAll('slideshow-component.reviews--slide-container');

  // Apply the observer to each element
  slideshows.forEach((slideshow) => {
    const className = getClassForLogic(slideshow);
    const customLogicFunction = customLogic[className];

    if (customLogicFunction) {
      initActiveAuthor(slideshow);
      observeCurrentPageChange(slideshow, customLogicFunction);
    }
  });

  window.addEventListener('click', handleClick);
})();
